(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  const mediaQuery = window.matchMedia('(min-width: 992px)');
  if (mediaQuery.matches) {
    document.querySelectorAll('.first-leavel-box a').forEach((item) => {
      item.addEventListener('mouseover', (e) => {
        e.preventDefault();
        if (item.closest('.mega-menu').querySelector('.first-leavel-box a.active')) {
          item.closest('.mega-menu').querySelector('.first-leavel-box a.active').classList.remove('active');
        }
        item.classList.add('active');
        let id = item.getAttribute('data-id');
        if (item.closest('.mega-menu').querySelector('.second-leavel-box.active')) {
          item.closest('.mega-menu').querySelector('.second-leavel-box.active').classList.remove('active');
          if (item.closest('.mega-menu').querySelector('.megamenu-box.active')) {
            item.closest('.mega-menu').querySelector('.megamenu-box.active').classList.remove('active');
          }
        }
        
        if (item.closest('.mega-menu').querySelector('.second-leavel-box .second-leavel-menu-wrapper.open')) {
          item.closest('.mega-menu').querySelector('.second-leavel-box .second-leavel-menu-wrapper.open').classList.remove('open');
          if (item.closest('.mega-menu').querySelector('.megamenu-box .menu-box.open')) {
            item.closest('.mega-menu').querySelector('.megamenu-box .menu-box.open').classList.remove('open');
          }
        }
        if (item.closest('.mega-menu').querySelector(`.second-leavel-box ${id}`)) {
          item.closest('.mega-menu').querySelector(`.second-leavel-box ${id}`).closest('.second-leavel-box').classList.add('active');
          item.closest('.mega-menu').querySelector(`.second-leavel-box ${id}`).classList.add('open');
          if (item.closest('.mega-menu').querySelector('.second-leavel-box a.active')) {
            item.closest('.mega-menu').querySelector('.second-leavel-box a.active').classList.remove('active');
          }
          item.closest('.mega-menu').querySelector(`.second-leavel-box ${id} .menu-item:first-child`).classList.add('active');
          let menuId = item.closest('.mega-menu').querySelector(`.second-leavel-box ${id} .menu-item:first-child`).getAttribute('data-id');
          if (item.closest('.mega-menu').querySelector('.megamenu-box .menu-box.open')) {
            item.closest('.mega-menu').querySelector('.megamenu-box .menu-box.open').classList.remove('open');
          }
          if (item.closest('.mega-menu').querySelector(`.megamenu-box ${menuId}`)) {
            item.closest('.mega-menu').querySelector(`.megamenu-box ${menuId}`).closest('.megamenu-box').classList.add('active');
            item.closest('.mega-menu').querySelector(`.megamenu-box ${menuId}`).classList.add('open');
          }
        }
      });
    });
    
    document.querySelectorAll('.second-leavel-box a').forEach((item) => {
      item.addEventListener('mouseover', (e) => {
        e.preventDefault();
        if (item.closest('.mega-menu').querySelector('.second-leavel-box a.active')) {
          item.closest('.mega-menu').querySelector('.second-leavel-box a.active').classList.remove('active');
        }
        item.classList.add('active');
        let id = item.getAttribute('data-id');
        if (item.closest('.mega-menu').querySelector('.megamenu-box.active')) {
          item.closest('.mega-menu').querySelector('.megamenu-box.active').classList.remove('active');
        }
        if (item.closest('.mega-menu').querySelector('.megamenu-box .menu-box.open')) {
          item.closest('.mega-menu').querySelector('.megamenu-box .menu-box.open').classList.remove('open');
        }
        if (item.closest('.mega-menu').querySelector(`.megamenu-box ${id}`)) {
          item.closest('.mega-menu').querySelector(`.megamenu-box ${id}`).closest('.megamenu-box').classList.add('active');
          item.closest('.mega-menu').querySelector(`.megamenu-box ${id}`).classList.add('open');
        }
      });
    }); 

    
  }

  } catch(e) { console.error(e); }
})();
})();
